export interface SocialNetwork {
  platform: "instagram" | "youtube" | "tiktok" | "facebook" | "twitter" | "linkedin" | "twitch";
  followers: string;
  url: string;
}

export interface Talent {
  id: number;
  name: string;
  category: string;
  totalFollowers: string;
  engagement: string;
  socials: SocialNetwork[];
  photos: string[];
  photoPosition?: string; // CSS object-position value e.g. "center 15%"
  photoZoom?: number; // optional zoom for the profile photo e.g. 1.2
  photoShiftX?: number; // optional horizontal shift in % (negative moves the subject left)
  tags: string[];
  bio: string;
  bioEn?: string;
}

export const talents: Talent[] = [
  {
    id: 1,
    name: "Abigelic",
    category: "BEAUTY & MAKEUP",
    totalFollowers: "11.5M",
    engagement: "10.5%",
    bio: "Su propuesta visual destaca por su estética única y una narrativa orgánica que conecta de forma genuina con su audiencia.",
    bioEn: "Her visual style stands out for its unique aesthetic and organic storytelling that genuinely connects with her audience.",
    socials: [
      { platform: "tiktok", followers: "7.1M", url: "https://www.tiktok.com/@abigelic" },
      { platform: "facebook", followers: "2.7M", url: "https://www.facebook.com/abigelic" },
      { platform: "instagram", followers: "1.4M", url: "https://www.instagram.com/abigelic" },
      { platform: "youtube", followers: "385K", url: "https://www.youtube.com/@abigelic./videos" },
    ],
    photoPosition: "center 10%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/ac112321efaf07af7a79a513ad31d9e5.jpeg",
      "https://readdy.ai/api/search-image?query=young%20latina%20woman%20beauty%20content%20creator%20artistic%20colorful%20makeup%20editorial%20portrait%20studio%20vibrant%20bold%20aesthetic%20dramatic%20lighting%20close%20up&width=900&height=1100&seq=ab1b&orientation=portrait",
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/94761d14d77811fdf28f9ad6907023d7.jpeg",
    ],
    tags: ["Beauty", "Lifestyle", "Fashion", "Music"],
  },
  {
    id: 2,
    name: "Fer Zepeda",
    category: "ACTRESS & LIFESTYLE",
    totalFollowers: "6.9M",
    engagement: "7.4%",
    bio: "Con una trayectoria de 13 años en TV, su perfil combina la madurez de la televisión con la frescura digital, colaborando con marcas globales.",
    bioEn: "With a 13-year career in television, she blends the polish of TV with a fresh digital edge, working with global brands.",
    socials: [
      { platform: "tiktok", followers: "6.1M", url: "https://www.tiktok.com/@fer.fzr" },
      { platform: "instagram", followers: "614K", url: "https://www.instagram.com/fer.fzr" },
      { platform: "facebook", followers: "233K", url: "https://www.facebook.com/fer.fzrmx" },
    ],
    photoPosition: "center 20%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/9c5ec98f2ad054bd46a83361abdb3582.jpeg",
      "https://readdy.ai/api/search-image?query=young%20latina%20actress%20digital%20content%20creator%20editorial%20fashion%20portrait%20natural%20light%20outdoor%20stylish%20chic%20confident%20pose%20modern%20aesthetic&width=900&height=1100&seq=fz2b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20latina%20TV%20actress%20beauty%20lifestyle%20influencer%20glamorous%20portrait%20studio%20soft%20pink%20tones%20elegant%20makeup%20fashion%20magazine%20style&width=900&height=1100&seq=fz2c&orientation=portrait",
    ],
    tags: ["Acting", "Fashion", "Beauty"],
  },
  {
    id: 3,
    name: "Evelyn Rangel",
    category: "TRAVEL & LIFESTYLE",
    totalFollowers: "10.6M",
    engagement: "7.6%",
    bio: "Viajera y storyteller con una narrativa auténtica y cercana que inspira a millones de jóvenes mediante su contenido.",
    bioEn: "A traveler and storyteller whose authentic, relatable voice inspires millions of young people through her content.",
    socials: [
      { platform: "tiktok", followers: "8.7M", url: "https://www.tiktok.com/@evelyn_rangeel" },
      { platform: "youtube", followers: "1.3M", url: "https://www.youtube.com/@EvelynRangel" },
      { platform: "instagram", followers: "561K", url: "https://www.instagram.com/evelyn_rangeel" },
      { platform: "facebook", followers: "123K", url: "https://www.facebook.com/evelnc" },
    ],
    photoPosition: "center 20%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/f9207f896952a8efffebb2127966dd34.jpeg",
      "https://readdy.ai/api/search-image?query=young%20latina%20woman%20travel%20storyteller%20influencer%20portrait%20mountain%20landscape%20nature%20background%20casual%20fashion%20editorial%20natural%20light%20authentic%20smile&width=900&height=1100&seq=er3b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20latina%20travel%20influencer%20content%20creator%20urban%20city%20portrait%20stylish%20outfit%20editorial%20photography%20colorful%20background%20vibrant%20confident%20pose&width=900&height=1100&seq=er3c&orientation=portrait",
    ],
    tags: ["Travel", "Fashion", "Storytelling"],
  },
  {
    id: 4,
    name: "Yamirootz",
    category: "FESTIVALS & BEAUTY",
    totalFollowers: "7.3M",
    engagement: "8.6%",
    bio: "Destaca por un contenido vibrante y energía única que fusiona el baile, los viajes y la cobertura de los festivales más importantes de México.",
    bioEn: "She stands out for vibrant content and a unique energy that blends dance, travel and coverage of Mexico's biggest festivals.",
    socials: [
      { platform: "tiktok", followers: "6.8M", url: "https://www.tiktok.com/@yamirootz" },
      { platform: "instagram", followers: "538K", url: "https://www.instagram.com/yamirootz__" },
    ],
    photoPosition: "center 20%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/9e2cd2bb23a0a3ba51e82c778e6e6831.jpeg",
      "https://readdy.ai/api/search-image?query=young%20latina%20woman%20festival%20content%20creator%20portrait%20outdoor%20music%20event%20colorful%20outfit%20creative%20makeup%20artistic%20vibrant%20joyful%20pose&width=900&height=1100&seq=ym4b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20latina%20dancer%20beauty%20influencer%20portrait%20studio%20dramatic%20lighting%20bold%20festival%20makeup%20fashion%20editorial%20vivid%20colors%20expressive%20confident&width=900&height=1100&seq=ym4c&orientation=portrait",
    ],
    tags: ["Lifestyle", "Festivals", "Makeup", "Fashion"],
  },
  {
    id: 5,
    name: "Vale de la Cuesta",
    category: "ENTERTAINMENT & COMEDY",
    totalFollowers: "3.4M",
    engagement: "9.2%",
    bio: "Su capacidad para conectar la narrativa auténtica e integra belleza y estilo de vida con un sello de comedia genuino, la ha llevado de liderar podcasts a incursionar en el stand-up.",
    bioEn: "Her gift for authentic storytelling — blending beauty and lifestyle with a genuine comedic edge — has taken her from hosting podcasts to performing stand-up.",
    socials: [
      { platform: "tiktok", followers: "2.6M", url: "https://www.tiktok.com/@valentinadelacuesta" },
      { platform: "facebook", followers: "404K", url: "https://www.facebook.com/vale.delacuesta" },
      { platform: "instagram", followers: "442K", url: "https://www.instagram.com/valedelacuesta" },
      { platform: "youtube", followers: "20K", url: "https://www.youtube.com/@valedelacuesta" },
    ],
    photoPosition: "center 10%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/311fab9bf847ad4f805931c91a5c4469.jpeg",
      "https://readdy.ai/api/search-image?query=young%20latina%20content%20creator%20comedy%20podcast%20host%20portrait%20studio%20colorful%20backdrop%20energetic%20personality%20humorous%20authentic%20real%20bold&width=900&height=1100&seq=vdc5b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20latina%20woman%20entertainer%20beauty%20lifestyle%20influencer%20portrait%20warm%20studio%20light%20elegant%20casual%20fashion%20authentic%20smile%20relatable%20pose&width=900&height=1100&seq=vdc5c&orientation=portrait",
    ],
    tags: ["Comedy", "Beauty", "Standup"],
  },
  {
    id: 6,
    name: "Emily Rangel",
    category: "BOOKTOK & ENTERTAINMENT",
    totalFollowers: "2.2M",
    engagement: "11.4%",
    bio: "Creadora que ha redefinido el impacto entre la Gen Z a través de una narrativa multiplataforma, equilibra la agilidad del contenido corto con la profundidad de sus reseñas de libros, viajes y estilo de vida.",
    bioEn: "A creator who has redefined what impact looks like for Gen Z through multiplatform storytelling, balancing the speed of short-form content with the depth of her book, travel and lifestyle reviews.",
    socials: [
      { platform: "tiktok", followers: "1.3M", url: "https://www.tiktok.com/@emily.rangeel" },
      { platform: "youtube", followers: "524K", url: "https://www.youtube.com/@EmilyRangeel" },
      { platform: "instagram", followers: "471K", url: "https://www.instagram.com/emily.rangeel" },
    ],
    photoPosition: "center 10%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/0f246493e89cea3f13637e8754f636c7.png",
      "https://readdy.ai/api/search-image?query=young%20latina%20content%20creator%20books%20travel%20lifestyle%20portrait%20outdoor%20natural%20light%20editorial%20fashion%20minimal%20aesthetic%20storytelling%20Gen%20Z%20authentic&width=900&height=1100&seq=emr6b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20latina%20woman%20entertainment%20digital%20creator%20portrait%20studio%20modern%20minimal%20background%20confident%20expressive%20vibrant%20personality%20multiplataforma%20influencer&width=900&height=1100&seq=emr6c&orientation=portrait",
    ],
    tags: ["Storytelling", "Lifestyle", "Books", "Travel"],
  },
  {
    id: 8,
    name: "Nicole Reyes",
    category: "ACTRESS & ENTERTAINMENT",
    totalFollowers: "1M",
    engagement: "6.3%",
    bio: "Nicole ha consolidado su presencia artística tanto en televisión como en teatro musical. Su experiencia abarca producciones de gran alcance como \"El Señor de los Cielos\" y \"Narcos México\".",
    bioEn: "With a diverse and solid career in entertainment, Nicole has established herself as a strong presence in both television and musical theater. Her credits include large-scale productions such as \"El Señor de los Cielos\" and \"Narcos Mexico\".",
    socials: [
      { platform: "tiktok", followers: "900K", url: "https://www.tiktok.com/@nicolereyesof" },
      { platform: "instagram", followers: "180K", url: "https://www.instagram.com/nicolereyesof" },
    ],
    photoPosition: "center 35%",
    photoZoom: 1.15,
    photoShiftX: 0,
    photos: [
      "https://storage.helloreaddy.io/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/00774b31-caca-4022-aa3f-c679ee43df82_compressed_IMG_0534.webp",
      "https://readdy.ai/api/search-image?query=young%20latina%20digital%20creator%20beauty%20lifestyle%20portrait%20outdoor%20natural%20light%20stylish%20casual%20outfit%20editorial%20photography%20vibrant%20modern%20aesthetic&width=900&height=1100&seq=nt8c&orientation=portrait",
    ],
    tags: ["Acting", "Entertainment", "Fashion"],
  },
  {
    id: 7,
    name: "Sebasti Eng",
    category: "ACTOR & FASHION",
    totalFollowers: "639K",
    engagement: "6.7%",
    bio: "Su crecimiento constante en redes sociales se basa en una propuesta auténtica que resuena directamente con la Gen Z, logrando una conexión de alta fidelidad que trasciende la pantalla.",
    bioEn: "His steady growth on social media comes from an authentic approach that resonates with Gen Z, building a genuine connection that transcends the screen.",
    socials: [
      { platform: "tiktok", followers: "585K", url: "https://www.tiktok.com/@sebastieng" },
      { platform: "instagram", followers: "54K", url: "https://www.instagram.com/sebasti.eng" },
    ],
    photoPosition: "center 10%",
    photos: [
      "https://static.readdy.ai/image/206e3a23f84eeca55b0a1d27380ad96c/243a97a85ee19a7378eebb1d93858778.jpeg",
      "https://readdy.ai/api/search-image?query=young%20latin%20man%20fashion%20content%20creator%20editorial%20portrait%20outdoor%20urban%20street%20style%20modern%20architecture%20background%20trendy%20outfit%20confident%20pose&width=900&height=1100&seq=se7b&orientation=portrait",
      "https://readdy.ai/api/search-image?query=young%20latin%20male%20actor%20lifestyle%20influencer%20portrait%20dramatic%20studio%20lighting%20sharp%20fashion%20look%20expressive%20face%20authentic%20personality%20high%20fidelity%20Gen%20Z&width=900&height=1100&seq=se7c&orientation=portrait",
    ],
    tags: ["Lifestyle", "Male Beauty", "Entertainment"],
  },
];

export const successCases = [
  {
    id: 1,
    brand: "L\'Oréal México",
    talent: "Abigelic",
    result: "+420% en engagement",
    description: "Campaña de lanzamiento de nueva línea de maquillaje con contenido auténtico que generó conversación orgánica masiva.",
    image: "https://readdy.ai/api/search-image?query=loreal%20beauty%20brand%20campaign%20collaboration%20influencer%20marketing%20makeup%20product%20launch%20modern%20editorial%20photography%20minimal%20clean%20elegant&width=600&height=400&seq=c1&orientation=landscape",
    category: "Beauty & Makeup",
  },
  {
    id: 2,
    brand: "Sephora LATAM",
    talent: "Emily Rangel",
    result: "3.1M de impresiones",
    description: "Serie de contenido multiplataforma sobre skincare y libros que conectó auténticamente con la audiencia Gen Z.",
    image: "https://readdy.ai/api/search-image?query=sephora%20beauty%20skincare%20campaign%20influencer%20marketing%20editorial%20photography%20clean%20minimal%20background%20product%20luxury&width=600&height=400&seq=c2&orientation=landscape",
    category: "Beauty & Entertainment",
  },
  {
    id: 3,
    brand: "Volaris",
    talent: "Evelyn Rangel",
    result: "22K conversiones directas",
    description: "Campaña de viajes con narrativa storytelling auténtica que inspiró a millones a reservar vuelos.",
    image: "https://readdy.ai/api/search-image?query=travel%20airline%20brand%20campaign%20influencer%20marketing%20lifestyle%20editorial%20photography%20airport%20destination%20warm%20tones%20adventure&width=600&height=400&seq=c3&orientation=landscape",
    category: "Travel & Lifestyle",
  },
];
